import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class CreateReceiptSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = 'e2364b35cdd84c278f43d60433c462df';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.CreateReceipt;

  private constructor() {
    super();
  }

  get $typeId(): string {
    return CreateReceiptSideEffect.TYPE_ID;
  }

  static create(): CreateReceiptSideEffect {
    return new CreateReceiptSideEffect();
  }

  static fromMap(_context: SerializationContext, _map: SerializedData): CreateReceiptSideEffect {
    return new CreateReceiptSideEffect();
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
    };
  }

  clone(): this {
    return new CreateReceiptSideEffect() as this;
  }

  isSame(other: CreateReceiptSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType;
  }

  toLegacyOrderHook(): LegacyOrderHook | null {
    return null;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof CreateReceiptSideEffect;
  }

  static assertType(order: DataModel): order is CreateReceiptSideEffect {
    return order instanceof CreateReceiptSideEffect;
  }
}

export class CreateReceiptSideEffectBuilder extends DataModelBuilder<CreateReceiptSideEffect> {
  build(context: SerializationContext, map: SerializedData): CreateReceiptSideEffect {
    return CreateReceiptSideEffect.fromMap(context, map);
  }
}
